export const getAcademicYearByDate = (date: Date): string => {
  const month = date.getMonth();
  const fullYear = date.getFullYear();
  // Если сентябрь - декабрь, то задаем текущий год даты, как начало периода
  // иначе предыдущий год
  const startDate = month > 7 ? fullYear : fullYear - 1;
  return `${startDate}-${startDate + 1}`;
};
